import { render, staticRenderFns } from "./PainelLoteEdicao.vue?vue&type=template&id=b81e4e96"
import script from "./PainelLoteEdicao.vue?vue&type=script&lang=js"
export * from "./PainelLoteEdicao.vue?vue&type=script&lang=js"
import style0 from "./PainelLoteEdicao.vue?vue&type=style&index=0&id=b81e4e96&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports